module.exports = __webpack_public_path__ + "img/web-icon.9f0a0ac1.svg";